import {
  cleanupQuery,
  parseFilterArrayFromQuery,
  parseTableOptionsFromQuery,
  readListQueryFromSession,
} from '@/utils/listRouteState'

const CANDIDATE_QUERY_KEYS = ['cStage', 'cQ', 'cPage', 'cSize', 'cSortBy', 'cSortDesc']

const listSessionKeyForJob = (jobId) => `apps-ats-job-view-candidates:${jobId}`

const candidateListParamsPresent = (query) => {
  const cleaned = cleanupQuery(query)
  return CANDIDATE_QUERY_KEYS.some((k) => Object.prototype.hasOwnProperty.call(cleaned, k))
}

const parseCandidateSearchFromQuery = (query) => (typeof query.cQ === 'string' ? query.cQ : '')

const resolveCandidateListQuery = (routeQuery, jobId) => {
  if (candidateListParamsPresent(routeQuery)) {
    return routeQuery
  }
  const stored = readListQueryFromSession(listSessionKeyForJob(jobId))
  if (stored) {
    return { ...routeQuery, ...stored }
  }
  return routeQuery
}

/**
 * Query params for GET candidate detail when list_navigation=1 —
 * mirrors getJobCandidates / CandidateOfferViewList.
 */
export function buildCandidateListNavigationParams(routeQuery, jobId) {
  const query = resolveCandidateListQuery(routeQuery, jobId)
  const defaults = {
    sortDesc: [true],
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
  }
  const options = parseTableOptionsFromQuery(
    {
      page: query.cPage,
      size: query.cSize,
      sortBy: query.cSortBy,
      sortDesc: query.cSortDesc,
    },
    defaults,
  )
  const ordering = options.sortBy.map((el, index) => {
    const parsedEl = el
      .replaceAll('.', '__')
      .replace('gdprStatus', 'gdpr_status')
      .replace('name', 'candidate__user__last_name')

    return `${options.sortDesc[index] ? '-' : ''}${parsedEl}`
  })

  return {
    list_navigation: '1',
    stage: parseFilterArrayFromQuery(query, 'cStage'),
    search: parseCandidateSearchFromQuery(query),
    ordering,
  }
}
